/* DoughRise Design System — Vanilla JS Utilities */

(function () {
  'use strict';

  // Signals to CSS that JS is alive — gates the .dr-reveal no-JS failsafe
  document.documentElement.classList.add('dr-js');

  // ─── Scroll Reveal ──────────────────────────────────────────
  function initScrollReveal() {
    var elements = document.querySelectorAll('.dr-reveal');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      elements.forEach(function (el) { observer.observe(el); });
    } else {
      // Fallback for older browsers
      elements.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // ─── Animated Counters ──────────────────────────────────────
  function animateCounter(el) {
    var target = parseFloat(el.dataset.target !== undefined ? el.dataset.target : el.dataset.counter);
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var decimals = parseInt(el.dataset.decimals || el.dataset.dec || '0');
    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = eased * target;
      el.textContent = prefix + current.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });

      counters.forEach(function (el) { observer.observe(el); });
    } else {
      counters.forEach(function (el) {
        el.textContent = (el.dataset.prefix || '') + el.dataset.target + (el.dataset.suffix || '');
      });
    }
  }

  // ─── Pricing Toggle (Annual / Monthly) ──────────────────────
  function initPricingToggle() {
    var toggle = document.getElementById('dr-billing-toggle');
    if (!toggle) return;

    var monthlyPrices = document.querySelectorAll('[data-price-monthly]');
    var annualPrices  = document.querySelectorAll('[data-price-annual]');
    var billingLabel  = document.getElementById('dr-billing-label');

    function update() {
      var isAnnual = toggle.checked;
      monthlyPrices.forEach(function (el) {
        el.style.display = isAnnual ? 'none' : '';
      });
      annualPrices.forEach(function (el) {
        el.style.display = isAnnual ? '' : 'none';
      });
      if (billingLabel) {
        billingLabel.textContent = isAnnual ? 'Billed annually (save up to 33%)' : 'Billed monthly';
      }
    }

    toggle.addEventListener('change', update);

    // Pre-select annual when arriving via /pages/pricing#annual (cart upsell link).
    // Dispatch a real change event so section-specific handlers (price labels,
    // save badge) update too, not just this shared price-swap logic.
    if (window.location.hash === '#annual' && !toggle.checked) {
      toggle.checked = true;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    }

    update(); // set initial state
  }

  // ─── Init on DOM Ready ───────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initScrollReveal();
    initCounters();
    initPricingToggle();
    initUnitToggle();
  }

  function initUnitToggle() {
    var sys = localStorage.getItem('dr_units') || 'metric';
    // Deliberately calls drApplyUnit (not drSetUnit) on page load.
    // drSetUnit would also trigger updateCalcUnitUI — but on the calculator page
    // the existing DOMContentLoaded handler already calls it independently.
    // Calling it again from here would be redundant and order-dependent.
    drApplyUnit(sys);
  }
})();

// ─── Global unit preference (sitewide) ───────────────────────────────────────
// Note: setUnitSystem() from calculators-suite.liquid is calculator-page only.
// drSetUnit writes the same localStorage key and works on every page.
function drSetUnit(sys) {
  localStorage.setItem('dr_units', sys);
  drApplyUnit(sys);
  // If on the calculator page, sync its unit bar immediately
  if (typeof updateCalcUnitUI === 'function') updateCalcUnitUI();
}

function drApplyUnit(sys) {
  document.querySelectorAll('.dr-unit-nav-btn').forEach(function(btn) {
    var active = btn.dataset.unit === sys;
    btn.style.background = active ? '#904D00' : 'transparent';
    btn.style.color = active ? '#fff' : 'rgba(255,255,255,0.5)';
  });
}

// ─── Global gate-hit tracker ─────────────────────────────────────────────────
// Fires a single `gate.hit` event when a free (logged-out / non-Pro) user
// clicks any "upgrade to Pro" CTA anywhere on the storefront. This is the
// Pro-wall signal the free->Pro lifecycle / churn agents key off. Pro users are
// excluded (they don't see these CTAs). Best-effort, never blocks navigation.
(function () {
  function drFireEvent(type, meta) {
    try {
      fetch('https://api.doughrise.store/api/events/client', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true, // survive the page navigation the click triggers
        body: JSON.stringify({ type: type, meta: meta || {} })
      }).catch(function () {});
    } catch (e) {}
  }
  // Exposed so calculators / studios can report client-side Pro actions too,
  // e.g. drFireEvent('recipe.exported', { tool: 'pizza-studio' }).
  window.drFireEvent = drFireEvent;

  document.addEventListener('click', function (e) {
    if (window.__drIsPro) return;
    if (!e.target.closest) return;
    var link = e.target.closest('a[href*="doughrise-pro"], [data-dr-gate]');
    if (!link) return;
    var tool = link.getAttribute('data-dr-gate') || link.getAttribute('data-dr-tool') || 'unknown';
    drFireEvent('gate.hit', { tool: tool, href: link.getAttribute('href') || '' });
  }, true);
})();

// ─── Global newsletter-capture handler ────────────────────────────────────────
// Any form marked [data-dr-newsletter-form] anywhere on the site (footer, popup,
// the reusable newsletter-form snippet) is intercepted here and posted to the
// doughrise leads API instead of Shopify's native customer-account form — native
// Shopify newsletter forms create raw Shopify Customer records, bypassing the
// leads funnel/cockpit entirely. One delegated listener covers every instance,
// present or future, without each Liquid file needing its own fetch logic.
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-dr-newsletter-form]');
    if (!form) return;
    e.preventDefault();

    var emailEl = form.querySelector('[data-dr-newsletter-email]');
    var btn = form.querySelector('[data-dr-newsletter-submit]');
    var msg = form.querySelector('[data-dr-newsletter-msg]');
    var email = ((emailEl && emailEl.value) || '').trim().toLowerCase();

    function setMsg(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.style.display = 'block';
      msg.style.color = isError ? '#c0392b' : '';
    }

    if (!EMAIL_RE.test(email)) {
      setMsg('Please enter a valid email address.', true);
      if (emailEl) emailEl.focus();
      return;
    }

    // Consent comes from the form's own checkbox (snippets/dr-consent.liquid),
    // never assumed. A form with no box (e.g. the store waitlist, which promises
    // a single email and nothing else) sends consent:false.
    var consentBox = form.querySelector('[data-dr-consent]');
    if (consentBox && consentBox.hasAttribute('data-dr-consent-required') && !consentBox.checked) {
      setMsg('Please tick the box so I can send you the emails.', true);
      consentBox.focus();
      return;
    }
    var payload = {
      email: email,
      consent: false,
      source: form.getAttribute('data-dr-newsletter-source') || 'newsletter'
    };
    if (consentBox && consentBox.checked) {
      payload.consent = true;
      payload.consent_text_version = consentBox.getAttribute('data-dr-consent-version');
    }

    if (btn) btn.disabled = true;

    fetch('https://api.doughrise.store/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('bad response');
        if (emailEl) emailEl.style.display = 'none';
        if (btn) btn.style.display = 'none';
        if (consentBox && consentBox.closest('label')) consentBox.closest('label').style.display = 'none';
        setMsg(form.getAttribute('data-dr-newsletter-success') || 'Thanks, you are subscribed.', false);
        // P8-01: the one GA4 signup event (replaces the footer's generate_lead).
        if (window.drGa4Signup) window.drGa4Signup(payload.source);
        form.dispatchEvent(new CustomEvent('dr:newsletter:success', { bubbles: true }));
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        setMsg('Something went wrong, please try again in a moment.', true);
      });
  });
})();

// ── Deferred saved-formula flush ──────────────────────────────────────────────
// An anonymous "save this formula" returns 202 whether it created a brand-new account
// (formula persisted server-side) or only sent a login link to an existing account
// (formula NOT written — existing accounts are never written from an unauthenticated
// request). The response is deliberately identical in both cases (anti-enumeration), so
// the storefront stashes every such formula in localStorage (see calculators-suite).
// Here, once the visitor is logged in (dr_auth cookie), we replay the stash through the
// authenticated quick-save endpoint — the write happens under their real session, so
// nothing is dropped and no unauthenticated account write occurs. We first fetch the
// account's existing formulas and skip any stashed one whose (calculator_type, data)
// already matches, so the first formula (persisted at account creation) is not
// duplicated. Successful/already-present items are removed; failures stay stashed.
(function () {
  function loggedIn() { return /(?:^|;\s*)dr_auth=1/.test(document.cookie); }
  if (!loggedIn()) return;
  var API = 'https://api.doughrise.store', KEY = 'dr_pending_formulas', pending;
  try { pending = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { pending = []; }
  if (!pending.length) return;

  function key(f) { return (f.calculator_type || '') + '|' + (f.data || ''); }
  function save(f) {
    return fetch(API + '/api/formulas/quick-save', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ calculator_type: f.calculator_type, name: f.name, data: f.data, source_page: f.source_page })
    }).then(function (res) { return res.ok || res.status === 403; }) // 403 = free cap reached; consume so it is not retried forever
      .catch(function () { return false; });
  }

  function run() {
    fetch(API + '/formulas', { credentials: 'include' })
      .then(function (res) { return res.ok ? res.json() : []; })
      .catch(function () { return []; })
      .then(function (existing) {
        var have = {};
        (existing || []).forEach(function (f) { have[key(f)] = true; });
        var jobs = pending.map(function (f) {
          return have[key(f)] ? Promise.resolve(true) : save(f); // skip already-persisted
        });
        Promise.all(jobs).then(function (done) {
          var remaining = pending.filter(function (f, i) { return !done[i]; });
          try { if (remaining.length) localStorage.setItem(KEY, JSON.stringify(remaining)); else localStorage.removeItem(KEY); } catch (e) {}
          if (done.indexOf(true) !== -1) { try { window.dispatchEvent(new Event('dr:formulas-synced')); } catch (e) {} }
        });
      });
  }

  // Defer to DOMContentLoaded so page sections (e.g. my-formulas) have registered their
  // 'dr:formulas-synced' listener before we dispatch it.
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
